import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const quickLinks = [
    { label: t('nav_home'), path: '/' },
    { label: t('nav_categories'), path: '/category/xin-jing-jie-du' },
    { label: t('nav_about'), path: '/about' },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6">
        <div className="py-10 md:py-14 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-sm font-heading font-bold">
                空
              </span>
              <span className="text-lg font-heading font-bold text-foreground-900">
                {t('site_subtitle')}
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('footer_tagline')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-900 mb-3">
              {t('footer_links')}
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-900 mb-3">
              {t('footer_follow')}
            </h4>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-lg" />
              </a>
            </div>
          </div>
        </div>

        <div className="py-4 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-500">{t('footer_copyright')}</p>
          <p className="text-xs text-foreground-500">
            <a href={`mailto:${t('contact_email')}`} className="hover:text-foreground-700 transition-colors cursor-pointer">
              {t('contact_email')}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}